import {
  disableScrolling,
  enableScrolling,
} from './utils';

const signInDrawer = document.getElementById('js-sign-in-drawer');

let lastFocusedElement: HTMLElement | null = null;

if (signInDrawer) {
  initSignInDrawer(signInDrawer);
}

function initSignInDrawer(drawer: HTMLElement) {
  const closeBtns = drawer.querySelectorAll('.js-close-btn');
  const drawerToggles = document.querySelectorAll('.js-toggle-sign-in-drawer');
  const drawerOverlay = drawer.querySelector('.sign-in-drawer__overlay');

  drawerToggles.forEach((btn) => btn.addEventListener('click', openSignInDrawer));
  closeBtns.forEach((btn) => btn.addEventListener('click', closeSignInDrawer));
  drawerOverlay?.addEventListener('click', closeSignInDrawer);

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) {
      e.preventDefault();
      closeSignInDrawer();
    }
  });
}

export function openSignInDrawer() {
  if (!signInDrawer) {
    return;
  }

  lastFocusedElement = document.activeElement as HTMLElement;
  signInDrawer.classList.add('open');
  signInDrawer.removeAttribute('aria-hidden');
  signInDrawer.removeAttribute('inert');
  disableScrolling();
  signInDrawer.focus({ preventScroll: true });
}

export function closeSignInDrawer() {
  if (!signInDrawer) {
    return;
  }

  signInDrawer.classList.remove('open');
  signInDrawer.setAttribute('inert', '');
  signInDrawer.setAttribute('aria-hidden', 'true');
  enableScrolling();

  if (lastFocusedElement) {
    lastFocusedElement.focus({ preventScroll: true });
    lastFocusedElement = null;
  }
}
